export default __webpack_public_path__ + "static/media/emerald-stage.4f740db8.webp";